module.exports = __webpack_public_path__ + "media/images/bnr-kit-e3ceea835675b8ecb9143fd6a70f2890.png";